import React, { useState ,useEffect} from "react";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import {ApiUrl} from "../../../ApiUrl";

const termOptions = [
  { value: 1, label: "Half Yearly" },
  { value: 2, label: " Annual" },
];

const StudentSearch = () => {
  const [formData, setFormData] = useState({
    studentName: "",
    admissionNo: "",
    studentBarcode: "",
    fatherName: "",
    motherName: "",
    class: "",
    section: "",
    rollNo: "",
    schoolAdmissionNo: "",
    status: "ACTIVE",
  });
  const [classOptions, setClassOptions] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
   const [sectionOptions, setSectionOptions] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);
  const [studentData, setStudentData] = useState([]);
  const [selectedTerms, setSelectedTerms] = useState({});
   


  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };






  const statusOptions = [
    { value: "ACTIVE", label: "ACTIVE" },
    { value: "INACTIVE", label: "INACTIVE" },
  ];
  useEffect(() => {
    fetch(`${ApiUrl.apiurl}Class/GetAllClass/`)
      .then((res) => res.json())
      .then((data) => {
        if (data.message === "Success") {
          const options = data.data.map((cls) => ({
            value: cls.id,
            label: cls.classname,
          }));
          setClassOptions(options);
        }
      })
      .catch((err) => console.error("Error fetching classes:", err));
  }, []);

  useEffect(() => {
    if (selectedClass) {
      fetch(
        `${ApiUrl.apiurl}ClassSectionBind/GetAllSectionBindWithClass/${selectedClass.value}/`
      )
        .then((res) => res.json())
        .then((data) => {
          const options = data.data.map((sec) => ({
            value: sec.section_id,
            label: sec.sectionname,
          }));
          setSectionOptions(options);
          setSelectedSection(null);
        });
    }
  }, [selectedClass]);


 const handleSearch = () => {
   const academicSessionId = localStorage.getItem("academicSessionId");
   const orgId = localStorage.getItem("orgId");
   const branchId = localStorage.getItem("branchId");

   const classId = selectedClass?.value;
   if (!classId) {
     alert("Please select a Class.");
     return;
   }

   const queryParams = new URLSearchParams({
     academic_year_id: academicSessionId,
     org_id: orgId,
     branch_id: branchId,
     class_id: classId,
     is_active: formData.status === "ACTIVE" ? "1" : "0",
   });

   if (formData.studentName)
     queryParams.append("student_name", formData.studentName);
   if (formData.admissionNo)
     queryParams.append("admission_no", formData.admissionNo);
   if (formData.studentBarcode)
     queryParams.append("barcord", formData.studentBarcode);
   if (selectedSection?.value)
     queryParams.append("section_id", selectedSection.value);
   if (formData.rollNo) queryParams.append("roll_no", formData.rollNo);
   if (formData.fatherName)
     queryParams.append("father_name", formData.fatherName);
   if (formData.motherName)
     queryParams.append("mother_name", formData.motherName);
   if (formData.schoolAdmissionNo)
     queryParams.append("registration_no", formData.schoolAdmissionNo);

   const apiUrl = `${
     ApiUrl.apiurl
   }reportcard/studentlist/?${queryParams.toString()}`;

   fetch(apiUrl)
     .then((res) => {
       if (res.status === 204 || res.status === 404) {
         return { data: [] };
       }
       if (!res.ok) {
         throw new Error("Network response was not ok");
       }
       return res.json();
     })
     .then((data) => {
       setStudentData(data.data || []);
       setCurrentPage(0);
     })
     .catch((error) => {
       console.error("Error fetching data:", error);
       setStudentData([]);
     });
 };


  const handleSelectChange = (selectedOption) => {
    setSelectedClass(selectedOption);
  };

  const handleClear = () => {
    setFormData({
      studentName: "",
      admissionNo: "",
      studentBarcode: "",
      fatherName: "",
      motherName: "",
      class: "",
      section: "",
      rollNo: "",
      schoolAdmissionNo: "",
      status: "ACTIVE",
    });
    setSelectedSection(null);
    setSelectedTerms({});
    setStudentData([]);
    setCurrentPage(0);
  };

  const offset = currentPage * itemsPerPage;
  const paginatedStudentData = studentData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(studentData.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };
  const handleAddDataClick = (student) => {
    const selectedTermId = selectedTerms[student.student_id];

    if (!selectedTermId) {
      alert("Please select term before adding exam data.");
      return;
    }

    const selectedTermOption = termOptions.find(
      (option) => String(option.value) === String(selectedTermId)
    );

    navigate("/admin/add-student-data", {
      state: {
        student,
        classId: selectedClass?.value || student?.class_id || "",
        termId: selectedTermId,
        termLabel: selectedTermOption?.label || "",
      },
    });
  };

  const handleViewReportClick = async (student) => {
    const selectedTermId = selectedTerms[student.student_id];

    if (!selectedTermId) {
      alert("Please select term before viewing exam report.");
      return;
    }

    const academicYearId = localStorage.getItem("academicSessionId") || "";
    const studentId = student.student_id || student.studentId || student.id;

    if (!studentId) {
      alert("Student details are missing.");
      return;
    }

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}reportcard/studentdocuments/?academic_year_id=${academicYearId}&student_id=${studentId}&term_id=${selectedTermId}`
      );

      const payload = await response.json();

      if (!response.ok) {
        throw new Error(payload?.message || "Unable to fetch exam report.");
      }

      const documents = Array.isArray(payload?.data) ? payload.data : [];
      const sortedDocuments = [...documents].sort((a, b) => {
        const aTime = a?.created_at ? new Date(a.created_at).getTime() : 0;
        const bTime = b?.created_at ? new Date(b.created_at).getTime() : 0;
        return bTime - aTime;
      });

      const report = sortedDocuments.find(
        (item) =>
          item?.file_path ||
          item?.document_file ||
          item?.uploaded_document_url ||
          item?.document_url ||
          item?.file_url
      );

      const reportUrl =
        report?.file_path ||
        report?.document_file ||
        report?.uploaded_document_url ||
        report?.document_url ||
        report?.file_url ||
        "";

      if (!reportUrl) {
        alert("No report found for the selected term.");
        return;
      }

      window.open(reportUrl, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error fetching exam report:", error);
      alert(error.message || "Unable to open exam report.");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT SEARCH
              </p>
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{ width: "150px" }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1  mt-2">
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="student-name" className="form-label">
                          Student Name
                        </label>
                        <input
  type="text"
  id="student-name"
  name="studentName"
  className="form-control detail"
  value={formData.studentName}
  onChange={handleInputChange}
/>

                      </div>


                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="student-barcode" className="form-label">
                          Student BarCode
                        </label>
                        <input
                          type="text"
                          name="studentBarcode"
                          className="form-control detail"
                          value={formData.studentBarcode}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="class" className="form-label">
                          Class
                        </label>
                        <Select
                          name="class"
                          className="detail"
                          value={selectedClass}
                          onChange={handleSelectChange}
                          options={classOptions}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="section" className="form-label">
                          Section
                        </label>
                        <Select
                          name="section"
                          className="detail"
                          value={selectedSection}
                          onChange={setSelectedSection}
                          options={sectionOptions}
                          // isDisabled={!selectedClass}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="roll-number" className="form-label">
                          Roll Number
                        </label>
                        <input
                          type="text"
                          name="rollNo"
                          className="form-control detail"
                          value={formData.rollNo}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="father-name" className="form-label">
                          Father Name
                        </label>
                        <input
                          type="text"
                          name="fatherName"
                          className="form-control detail"
                          value={formData.fatherName}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="mother-name" className="form-label">
                          Mother Name
                        </label>
                        <input
                          type="text"
                          className="form-control detail"
                          name="motherName"
                          value={formData.motherName}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="regn-number" className="form-label">
                          Registration No
                        </label>
                        <input
                          type="text"
                          name="schoolAdmissionNo"
                          className="form-control detail"
                          value={formData.schoolAdmissionNo}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <Select
                          name="status"
                          className="detail"
                          value={statusOptions.find(
                            (option) => option.value === formData.status
                          )}
                          onChange={(selectedOption) =>
                            handleInputChange({
                              target: { name: "status", value: selectedOption?.value },
                            })
                          }
                          options={statusOptions}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered ">
                    <thead>
                      <tr>
                        <th>Sr. No</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Student Name</th>
                        <th>Registraion No</th>
                        <th>Roll No</th>
                        <th>BarCode</th>
                        <th>Father Name</th>
                        <th>Mother Name</th>
                        <th>Select Term</th>
                        <th>Add Exam Data</th>
                        <th>View Exam Report</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedStudentData.length > 0 ? (
                        paginatedStudentData.map((student, index) => (
                          <tr key={student.id || index}>
                            <td>{offset + index + 1}</td>
                            <td>{student.class_name}</td>
                            <td>{student.section_name}</td>
                            <td>{student.student_name}</td>
                            <td>{student.registration_no}</td>
                            <td>{student.rollno}</td>
                            <td>{student.barcode}</td>
                            <td>{student.father_name}</td>
                            <td>{student.mother_name}</td>
                            <td>
                              <select
                                name="term"
                                className="form-select w-100"
                                value={selectedTerms[student.student_id] || ""}
                                onChange={(event) =>
                                  setSelectedTerms((prev) => ({
                                    ...prev,
                                    [student.student_id]: event.target.value,
                                  }))
                                }
                              >
                                <option value="">Select Term</option>
                                {termOptions.map((option, index) => (
                                  <option key={index} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                            </td>

                            <td>
                              <Button
                                variant="primary"
                                size="sm"
                                onClick={() => handleAddDataClick(student)}
                              >
                                Add Data
                              </Button>
                            </td>
                            <td>
                              <Button
                                variant="primary"
                                size="sm"
                                onClick={() => handleViewReportClick(student)}
                              >
                                View Report
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {pageCount > 1 && (
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination justify-content-center mt-3"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentSearch;
